var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSoloBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 16,
    viewBox: "0 0 39 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6277 0C32.7444 0 36.1429 3.04048 36.652 6.97436H39V9.02564H36.652C36.1429 12.9595 32.7444 16 28.6277 16C24.5109 16 21.1124 12.9595 20.6033 9.02564H18.3967C17.8876 12.9595 14.4891 16 10.3723 16C6.25556 16 2.85711 12.9595 2.34796 9.02564H0V6.97436H2.34796C2.85711 3.04048 6.25556 0 10.3723 0C13.8169 0 16.7582 2.12874 17.9253 5.12821H15.6418C14.6171 3.2938 12.6416 2.05128 10.3723 2.05128C7.04982 2.05128 4.35638 4.71461 4.35638 8C4.35638 11.2854 7.04982 13.9487 10.3723 13.9487C13.3411 13.9487 15.8074 11.8222 16.299 9.02564H10.1649V6.97436H20.6033C21.1124 3.04048 24.5109 0 28.6277 0ZM28.6277 2.05128C25.3051 2.05128 22.6117 4.71461 22.6117 8C22.6117 11.2854 25.3051 13.9487 28.6277 13.9487C31.9502 13.9487 34.6436 11.2854 34.6436 8C34.6436 4.71461 31.9502 2.05128 28.6277 2.05128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSoloBlanco);
export default __webpack_public_path__ + "static/media/logo_solo_blanco.8e6c5a9ff884eabca97ed11c51a46f89.svg";
export { ForwardRef as ReactComponent };